export default __webpack_public_path__ + "static/media/blue-check.c815f7dc.svg";